import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c17de2ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "element-loading-background": "rgba(0, 0, 0, 0.5)" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "装箱单/发票/合同信息")
], -1))
const _hoisted_3 = { class: "link" }
const _hoisted_4 = { class: "link" }
const _hoisted_5 = { class: "link" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "报关单")
], -1))
const _hoisted_7 = { style: {"text-align":"center","margin-top":"-25px","width":"100% !important"} }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","margin":"0px","padding":"0px"} }, " 预录入编号: ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"200px","margin":"0px auto"} }, " 海关编号: ", -1))
const _hoisted_12 = {
  key: 0,
  style: {"width":"200% !important","margin-left":"-100%"}
}
const _hoisted_13 = {
  cellpadding: "0",
  cellspacing: "0",
  class: "table"
}
const _hoisted_14 = {
  class: "cell",
  style: {"min-width":"380px !important"}
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_19 = {
  class: "cell",
  colspan: "2",
  style: {"max-width":"200px !important"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_21 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_22 = { class: "link" }
const _hoisted_23 = {
  class: "cell",
  colspan: "2"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_25 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_26 = {
  class: "cell",
  colspan: "2"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_28 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_29 = { class: "cell" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_31 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_32 = {
  class: "cell",
  style: {"min-width":"380px !important"}
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_37 = {
  class: "cell",
  colspan: "2",
  style: {"max-width":"200px !important"}
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_39 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_40 = {
  class: "cell",
  colspan: "2"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_42 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_43 = {
  key: 0,
  class: "cell",
  colspan: "3"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_45 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_46 = {
  key: 1,
  class: "cell",
  colspan: "2"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_48 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_49 = {
  key: 2,
  class: "cell"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"16px","height":"43px"} }, null, -1))
const _hoisted_52 = {
  class: "cell",
  style: {"min-width":"380px !important"}
}
const _hoisted_53 = { class: "link" }
const _hoisted_54 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_55 = { class: "link" }
const _hoisted_56 = {
  class: "cell",
  colspan: "2",
  style: {"max-width":"200px !important"}
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_58 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_59 = { class: "link" }
const _hoisted_60 = {
  class: "cell",
  colspan: "2"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_62 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_63 = { class: "link" }
const _hoisted_64 = {
  key: 0,
  class: "cell",
  colspan: "3"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_66 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_67 = {
  key: 1,
  class: "cell",
  colspan: "2"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_69 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_70 = {
  key: 2,
  class: "cell"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_72 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_73 = {
  class: "cell",
  style: {"min-width":"300px !important"}
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_75 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_76 = {
  class: "cell",
  colspan: "2",
  style: {"max-width":"200px !important"}
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_78 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_79 = { class: "link" }
const _hoisted_80 = {
  class: "cell",
  colspan: "2"
}
const _hoisted_81 = { key: 0 }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_83 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_84 = { class: "link" }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_87 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_88 = { class: "link" }
const _hoisted_89 = {
  class: "cell",
  colspan: "2"
}
const _hoisted_90 = { key: 0 }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_92 = ["title"]
const _hoisted_93 = { key: 1 }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_95 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_96 = { class: "link" }
const _hoisted_97 = { class: "cell" }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_100 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_101 = { key: 1 }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_103 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_104 = {
  class: "cell",
  style: {"min-width":"300px !important"}
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_106 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_107 = {
  class: "cell",
  style: {"min-width":"120px !important"}
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_109 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_110 = {
  class: "cell",
  style: {"min-width":"120px !important"}
}
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_112 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_113 = {
  class: "cell",
  style: {"min-width":"120px  !important"}
}
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_115 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_116 = {
  class: "cell",
  style: {}
}
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_118 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_119 = {
  class: "cell",
  style: {"min-width":"120px  !important"}
}
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_121 = { style: {"float":"right"} }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "币制 ", -1))
const _hoisted_123 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_124 = {
  class: "cell",
  style: {"min-width":"120px  !important"}
}
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_126 = { style: {"float":"right"} }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "币制 ", -1))
const _hoisted_128 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_129 = {
  class: "cell",
  style: {"min-width":"120px  !important"}
}
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_131 = { style: {"float":"right"} }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "币制 ", -1))
const _hoisted_133 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_134 = {
  class: "cell",
  colspan: "8",
  style: {"padding-bottom":"20px"}
}
const _hoisted_135 = { style: {"margin-top":"10px"} }
const _hoisted_136 = {
  class: "cell",
  colspan: "8",
  style: {"padding-top":"10px"}
}
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_138 = { style: {"width":"100%","height":"40px"} }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","font-size":"14px","font-weight":"900","line-height":"40px"} }, "产品信息", -1))
const _hoisted_140 = { style: {"float":"right","margin-top":"7px"} }
const _hoisted_141 = {
  key: 0,
  style: {"width":"100% !important"}
}
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", {
  cellpadding: "0",
  cellspacing: "0",
  style: {"clear":"both","width":"100% !important"}
}, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"4%"}
    }, "项号"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"9%"}
    }, "备案序号"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"7%"}
    }, "商品编号"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"15%"}
    }, "商品名称"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"10%"}
    }, "数量及单位"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"8%"}
    }, "单价/总价/币制"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"12%"}
    }, "原产国（地区）"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"12%"}
    }, "最终目的国（地区）"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"12%"}
    }, "境内货源地"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"6%"}
    }, "征免"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"5%"}
    }, "操作")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", {
      colspan: "12",
      class: "data",
      style: {"height":"40px","line-height":"40px","text-align":"center"}
    }, " 暂无数据 ")
  ])
], -1))
const _hoisted_143 = [
  _hoisted_142
]
const _hoisted_144 = { key: 1 }
const _hoisted_145 = {
  cellpadding: "0",
  cellspacing: "0",
  style: {"clear":"both","width":"100%"}
}
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"4%"}
  }, "项号"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"9%"}
  }, "备案序号"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"7%"}
  }, "商品编号"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"15%"}
  }, "商品名称"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"10%"}
  }, "数量及单位"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"8%"}
  }, "单价/总价/币制"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"12%"}
  }, "原产国（地区）"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"12%"}
  }, "最终目的国（地区）"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"12%"}
  }, "境内货源地"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"6%"}
  }, "征免"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"5%"}
  }, "操作")
], -1))
const _hoisted_147 = {
  class: "data",
  colspan: "20"
}
const _hoisted_148 = {
  class: "data",
  style: {"width":"100% !important","height":"100% !important"}
}
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_150 = ["innerHTML"]
const _hoisted_151 = {
  key: 0,
  style: {"margin":"0px","padding":"0px"}
}
const _hoisted_152 = { style: {"margin":"0px","padding":"0px"} }
const _hoisted_153 = { style: {"margin":"0px","padding":"0px"} }
const _hoisted_154 = { style: {"margin":"0px","padding":"0px"} }
const _hoisted_155 = { style: {"float":"left","width":"5%"} }
const _hoisted_156 = ["onClick"]
const _hoisted_157 = ["onClick"]
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"5px"} }, null, -1))
const _hoisted_159 = ["innerHTML"]
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, "选择包装种类", -1))
const _hoisted_161 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_162 = { style: {"clear":"both","height":"25px"} }
const _hoisted_163 = { style: {"font-size":"16px","line-height":"26px","margin-top":"-21px"} }
const _hoisted_164 = { style: {"clear":"both","height":"25px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_miezz_currency = _resolveComponent("miezz-currency")!
  const _component_miezz_customs_product = _resolveComponent("miezz-customs-product")!
  const _component_miezz_customs_package = _resolveComponent("miezz-customs-package")!
  const _component_company_business_card_form = _resolveComponent("company-business-card-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_company_business_card_bank_form = _resolveComponent("company-business-card-bank-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, null, {
      header: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          ref: "ruleForm",
          modelValue: _ctx.form,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form) = $event)),
          fix: true
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'OrderNumber')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      trim: false,
                      modelValue: _ctx.form.Data.OrderNumber,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.OrderNumber) = $event)),
                      placeholder: '请填写',
                      onHandleBlur: _ctx.onChangeOrderNumber
                    }, null, 8, ["modelValue", "onHandleBlur"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'OrderDate')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      clearable: false,
                      modelValue: _ctx.form.Data.OrderDate,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Data.OrderDate) = $event)),
                      style: {"width":"100% !important"},
                      type: "date",
                      "value-format": "YYYY/MM/DD",
                      placeholder: "请选择"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'InvoiceNumber')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      trim: false,
                      modelValue: _ctx.form.Data.InvoiceNumber,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Data.InvoiceNumber) = $event)),
                      placeholder: '请填写',
                      onHandleBlur: _ctx.onTrimSpace
                    }, null, 8, ["modelValue", "onHandleBlur"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'InvoiceDate')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 3,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      clearable: false,
                      modelValue: _ctx.form.Data.InvoiceDate,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Data.InvoiceDate) = $event)),
                      style: {"width":"100% !important"},
                      type: "date",
                      "value-format": "YYYY/MM/DD",
                      placeholder: "请选择"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'FirstConsignorId')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 4,
                  prop: item.Prop,
                  label: "发货人"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: "",
                      modelValue: _ctx.form.Data.FirstConsignorId,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Data.FirstConsignorId) = $event)),
                      clearable: true,
                      placeholder: "请选择",
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChangeFirstConsignorId(true)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shippers, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.Id,
                            label: item.Name,
                            value: item.Id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop"]))
              : _createCommentVNode("", true),
            (item.Prop == 'FirstConsigneeId')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 5,
                  prop: item.Prop,
                  label: "收货人"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: "",
                      modelValue: _ctx.form.Data.FirstConsigneeId,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.Data.FirstConsigneeId) = $event)),
                      clearable: true,
                      placeholder: "请选择",
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangeFirstConsigneeId(true)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consignees, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.Id,
                            label: item.Name,
                            value: item.Id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop"]))
              : _createCommentVNode("", true),
            (item.Prop == 'SellerContent')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 6,
                  prop: item.Prop,
                  label: "Sellers"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.Data.SellerContent,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.Data.SellerContent) = $event)),
                      autosize: { minRows: 5, maxRows: 5 },
                      type: "textarea",
                      placeholder: "请填写"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", {
                      style: {"font-size":"13px","color":"#fe995b","cursor":"pointer"},
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onSetConsignor && _ctx.onSetConsignor(...args)))
                    }, "更新到参数")
                  ]),
                  _: 2
                }, 1032, ["prop"]))
              : _createCommentVNode("", true),
            (item.Prop == 'BuyerContent')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 7,
                  prop: item.Prop,
                  label: "Buyers"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.Data.BuyerContent,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.Data.BuyerContent) = $event)),
                      autosize: { minRows: 5, maxRows: 5 },
                      type: "textarea",
                      placeholder: "请填写"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", {
                      style: {"font-size":"13px","color":"#fe995b","cursor":"pointer"},
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onSetConsignee && _ctx.onSetConsignee(...args)))
                    }, "更新到参数")
                  ]),
                  _: 2
                }, 1032, ["prop"]))
              : _createCommentVNode("", true),
            (item.Prop == 'CollectionBankId')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 8,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_miezz_select, {
                      placeholder: _ctx.form.Data.FirstConsignorId==undefined?'请先选择发货人':'请选择',
                      modelValue: _ctx.form.Data.CollectionBankId,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.Data.CollectionBankId) = $event)),
                      options: _ctx.shipperBanks,
                      key: _ctx.shipperBankRandom,
                      onHandleChange: _ctx.onChangeCollectionBank,
                      valueKey: "Id",
                      labelKey: "Name",
                      style: {"width":"100% !important"},
                      disabled: (_ctx.form.Data.FirstConsignorId==undefined)?true:false
                    }, null, 8, ["placeholder", "modelValue", "options", "onHandleChange", "disabled"]))
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'PaymentBankId')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 9,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_miezz_select, {
                      placeholder: _ctx.form.Data.FirstConsigneeId==undefined?'请先选择收货人':'请选择',
                      modelValue: _ctx.form.Data.PaymentBankId,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.Data.PaymentBankId) = $event)),
                      options: _ctx.consigneeBanks,
                      key: _ctx.consigneeBankRandom,
                      onHandleChange: _ctx.onChangePaymentBank,
                      valueKey: "Id",
                      labelKey: "Name",
                      style: {"width":"100% !important"},
                      disabled: _ctx.form.Data.FirstConsigneeId==undefined?true:false
                    }, null, 8, ["placeholder", "modelValue", "options", "onHandleChange", "disabled"]))
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'CollectionBankContent')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 10,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.Data.CollectionBankContent,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.Data.CollectionBankContent) = $event)),
                      autosize: { minRows: 5, maxRows: 5 },
                      type: "textarea",
                      disabled: (_ctx.form.Data.FirstConsignorId==undefined)?true:false,
                      placeholder: "请填写"
                    }, null, 8, ["modelValue", "disabled"]),
                    (_ctx.form.Data.FirstConsignorId!=undefined)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          style: {"font-size":"13px","color":"#fe995b","cursor":"pointer"},
                          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onSetCollectionBank && _ctx.onSetCollectionBank(...args)))
                        }, "更新到参数"))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'PaymentBankContent')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 11,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.Data.PaymentBankContent,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.Data.PaymentBankContent) = $event)),
                      autosize: { minRows: 5, maxRows: 5 },
                      type: "textarea",
                      disabled: (_ctx.form.Data.FirstConsigneeId==undefined)?true:false,
                      placeholder: "请填写"
                    }, null, 8, ["modelValue", "disabled"]),
                    (_ctx.form.Data.FirstConsigneeId!=undefined)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          style: {"font-size":"13px","color":"#fe995b","cursor":"pointer"},
                          onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onSetPaymentBank && _ctx.onSetPaymentBank(...args)))
                        }, "更新到参数"))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'DispatchPortId')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 12,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_autocomplete, {
                      modelValue: _ctx.form.Data.DispatchPortName,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.Data.DispatchPortName) = $event)),
                      clearable: false,
                      "fetch-suggestions": _ctx.querySearchDispatchPortAsync,
                      "popper-class": "my-autocomplete",
                      placeholder: "请填写关键词",
                      onSelect: _ctx.handleSelectDispatchPort,
                      onChange: _ctx.onChangeDispatchPortId
                    }, {
                      default: _withCtx(({ item }) => [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(item.Label), 1)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'DestinationPortId')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 13,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_autocomplete, {
                      modelValue: _ctx.form.Data.DestinationPortName,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.Data.DestinationPortName) = $event)),
                      clearable: false,
                      "fetch-suggestions": _ctx.querySearchDestinationPortAsync,
                      "popper-class": "my-autocomplete",
                      placeholder: "请填写关键词",
                      onSelect: _ctx.handleSelectDestinationPort,
                      onChange: _ctx.onChangeDestinationPortId
                    }, {
                      default: _withCtx(({ item }) => [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(item.Label), 1)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'ContactTransportModeId')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 14,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_select, {
                      modelValue: _ctx.form.Data.ContactTransportModeId,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.Data.ContactTransportModeId) = $event)),
                      options: _ctx.contactTransportModes,
                      valueKey: "Value",
                      labelKey: "Label",
                      style: {"width":"100% !important"}
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'Address')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 15,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      onHandleBlur: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onChangeAddress())),
                      trim: false,
                      modelValue: _ctx.form.Data.Address,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.Data.Address) = $event)),
                      placeholder: '请填写',
                      style: {"width":"100% !important"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'TradeTermsId')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 16,
                  prop: item.Prop,
                  label: "贸易条款"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: "",
                      modelValue: _ctx.form.Data.TradeTermsId,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.Data.TradeTermsId) = $event)),
                      clearable: true,
                      placeholder: "请选择",
                      onChange: _ctx.onChangeTradeTermsId
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tradeTerms, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.Value,
                            label: item.Label,
                            value: item.Value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["prop"]))
              : _createCommentVNode("", true),
            (item.Prop == 'DeliveryRequirement')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 17,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      onHandleBlur: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onChangeDeliveryRequirement())),
                      trim: false,
                      modelValue: _ctx.form.Data.DeliveryRequirement,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.Data.DeliveryRequirement) = $event)),
                      placeholder: '请填写',
                      style: {"width":"100% !important"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'PaymentTermsId')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 18,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: "",
                      modelValue: _ctx.form.Data.PaymentTermsId,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.Data.PaymentTermsId) = $event)),
                      clearable: true,
                      placeholder: "请选择",
                      onChange: _ctx.onChangePaymentTerms
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentTerms, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.Value,
                            label: item.Label,
                            value: item.Value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'PaymentTermsContent')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 19,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_autocomplete, {
                      modelValue: _ctx.form.Data.PaymentTermsContent,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.Data.PaymentTermsContent) = $event)),
                      clearable: true,
                      "fetch-suggestions": _ctx.querySearchPaymentTermsContentAsync,
                      "popper-class": "my-autocomplete",
                      placeholder: "请填写关键词",
                      onSelect: _ctx.handleSelectPaymentTermsContent
                    }, {
                      default: _withCtx(({ item }) => [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(item.Name), 1)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "fetch-suggestions", "onSelect"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'CreditNumber' && _ctx.isCredit==true)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  prop: item.Prop,
                  key: _ctx.creditRandom,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      trim: false,
                      modelValue: _ctx.form.Data.CreditNumber,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.Data.CreditNumber) = $event)),
                      placeholder: '请填写',
                      style: {"width":"100% !important"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'IssuingDate' && _ctx.isCredit==true)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  prop: item.Prop,
                  key: _ctx.creditRandom,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.form.Data.IssuingDate,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.Data.IssuingDate) = $event)),
                      style: {"width":"100% !important"},
                      type: "date",
                      "value-format": "YYYY/MM/DD",
                      placeholder: "请选择"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'OpenCertificateDays' && _ctx.isCredit==true)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  prop: item.Prop,
                  key: _ctx.creditRandom,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      trim: false,
                      modelValue: _ctx.form.Data.OpenCertificateDays,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.Data.OpenCertificateDays) = $event)),
                      onHandleBlur: _ctx.onChangeOpenCertificateDays,
                      placeholder: '请填写',
                      style: {"width":"100% !important"}
                    }, null, 8, ["modelValue", "onHandleBlur"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'ShippingMarks')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 23,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.Data.ShippingMarks,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.Data.ShippingMarks) = $event)),
                      autosize: { minRows: 5, maxRows: 5 },
                      type: "textarea",
                      placeholder: "请填写"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, { style: {"margin-top":"5px"} }, {
      header: _withCtx(() => [
        _hoisted_6
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          (_ctx.type=='10')
            ? (_openBlock(), _createElementBlock("h3", _hoisted_8, "中华人民共和国海关出口货物报关单（最新版）"))
            : (_ctx.type=='20')
              ? (_openBlock(), _createElementBlock("h3", _hoisted_9, "中华人民共和国海关进口货物报关单（最新版）"))
              : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_row, {
          gutter: 24,
          style: {"height":"30px","overflow":"hidden","font-size":"14px","line-height":"30px","margin-top":"-10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createTextVNode("   ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { gutter: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_form, {
                  ref: "ruleFormCustoms",
                  modelValue: _ctx.form,
                  "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.form) = $event)),
                  fix: true,
                  "label-position": "left"
                }, {
                  "form-item": _withCtx(({ item }) => [
                    (item.Prop == 'ConsignorCode')
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          "label-width": "0px"
                        }, {
                          default: _withCtx(() => [
                            (item.Prop == 'ConsignorCode')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createElementVNode("table", _hoisted_13, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_14, [
                                        (_ctx.type=='10')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                              _createElementVNode("div", null, [
                                                _createVNode(_component_el_form_item, {
                                                  label: "境内发货人",
                                                  "label-width": "95px",
                                                  prop: "ConsignorCode"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_miezz_input, {
                                                      trim: false,
                                                      modelValue: _ctx.form.Data.ConsignorCode,
                                                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.Data.ConsignorCode) = $event)),
                                                      placeholder: "请填写",
                                                      onHandleBlur: _ctx.onTrimSpace
                                                    }, null, 8, ["modelValue", "onHandleBlur"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _createElementVNode("div", _hoisted_16, [
                                                _createVNode(_component_el_form_item, {
                                                  "label-width": "25px",
                                                  label: " ",
                                                  prop: "ConsignorCompanyName"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_miezz_input, {
                                                      trim: false,
                                                      modelValue: _ctx.form.Data.ConsignorCompanyName,
                                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.Data.ConsignorCompanyName) = $event)),
                                                      placeholder: "请填写",
                                                      onHandleBlur: _ctx.onTrimSpace
                                                    }, null, 8, ["modelValue", "onHandleBlur"])
                                                  ]),
                                                  _: 1
                                                })
                                              ])
                                            ]))
                                          : (_ctx.type=='20')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "境内收货人",
                                                    "label-width": "85px",
                                                    prop: "ConsigneeCode"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_miezz_input, {
                                                        trim: false,
                                                        modelValue: _ctx.form.Data.ConsigneeCode,
                                                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.Data.ConsigneeCode) = $event)),
                                                        placeholder: "请填写",
                                                        onHandleBlur: _ctx.onTrimSpace
                                                      }, null, 8, ["modelValue", "onHandleBlur"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_18, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "25px",
                                                    label: " ",
                                                    prop: "ConsigneeCompanyName"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_miezz_input, {
                                                        trim: false,
                                                        modelValue: _ctx.form.Data.ConsigneeCompanyName,
                                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.Data.ConsigneeCompanyName) = $event)),
                                                        placeholder: "请填写",
                                                        onHandleBlur: _ctx.onTrimSpace
                                                      }, null, 8, ["modelValue", "onHandleBlur"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("td", _hoisted_19, [
                                        _createElementVNode("div", null, [
                                          _hoisted_20,
                                          _createVNode(_component_el_form_item, {
                                            label: _ctx.type=='10'?'申报地海关':'进境关别',
                                            "label-width": _ctx.type=='10'?'83px':'70px',
                                            style: {"margin-top":"-34px"}
                                          }, null, 8, ["label", "label-width"])
                                        ]),
                                        _createElementVNode("div", _hoisted_21, [
                                          _createVNode(_component_el_form_item, { "label-width": "0px" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_autocomplete, {
                                                modelValue: _ctx.form.Data.CustomhouseName,
                                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form.Data.CustomhouseName) = $event)),
                                                clearable: true,
                                                "fetch-suggestions": _ctx.querySearchCustomhouseIdAsync,
                                                "popper-class": "my-autocomplete",
                                                placeholder: "请填写关键词",
                                                onSelect: _ctx.handleSelectCustomhouseId,
                                                onChange: _ctx.onChangeCustomhouseId,
                                                onClear: _ctx.onChangeCustomhouseId
                                              }, {
                                                default: _withCtx(({ item }) => [
                                                  _createElementVNode("span", _hoisted_22, _toDisplayString(item.Label), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange", "onClear"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_23, [
                                        _createElementVNode("div", null, [
                                          _hoisted_24,
                                          _createVNode(_component_el_form_item, {
                                            label: _ctx.type=='10'?'出口日期':'进口日期',
                                            "label-width": "70px",
                                            style: {"margin-top":"-34px"}
                                          }, null, 8, ["label"])
                                        ]),
                                        _createElementVNode("div", _hoisted_25, [
                                          _createVNode(_component_el_form_item, { "label-width": "0px" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("   ")
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_26, [
                                        _createElementVNode("div", null, [
                                          _hoisted_27,
                                          _createVNode(_component_el_form_item, {
                                            label: "申报日期",
                                            "label-width": "70px",
                                            style: {"margin-top":"-34px"}
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_28, [
                                          _createVNode(_component_el_form_item, {
                                            "label-width": "0px",
                                            style: {"margin-top":"18px"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("   ")
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_29, [
                                        _createElementVNode("div", null, [
                                          _hoisted_30,
                                          _createVNode(_component_el_form_item, {
                                            label: "备案号",
                                            "label-width": "55px",
                                            style: {"margin-top":"-34px"}
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_31, [
                                          _createVNode(_component_el_form_item, {
                                            prop: "RecordNumber",
                                            "label-width": "0px"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_miezz_input, {
                                                modelValue: _ctx.form.Data.RecordNumber,
                                                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form.Data.RecordNumber) = $event))
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_32, [
                                        (_ctx.type=='10')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                              _createElementVNode("div", null, [
                                                _createVNode(_component_el_form_item, {
                                                  label: "境外收货人",
                                                  "label-width": "95px",
                                                  prop: "ConsigneeCode"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_miezz_input, {
                                                      trim: false,
                                                      modelValue: _ctx.form.Data.ConsigneeCode,
                                                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.form.Data.ConsigneeCode) = $event)),
                                                      placeholder: "请填写",
                                                      onHandleBlur: _ctx.onTrimSpace
                                                    }, null, 8, ["modelValue", "onHandleBlur"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _createElementVNode("div", _hoisted_34, [
                                                _createVNode(_component_el_form_item, {
                                                  "label-width": "25px",
                                                  label: " ",
                                                  prop: "ConsigneeCompanyName"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_miezz_input, {
                                                      trim: false,
                                                      modelValue: _ctx.form.Data.ConsigneeCompanyName,
                                                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.form.Data.ConsigneeCompanyName) = $event)),
                                                      placeholder: "请填写",
                                                      onHandleBlur: _ctx.onTrimSpace
                                                    }, null, 8, ["modelValue", "onHandleBlur"])
                                                  ]),
                                                  _: 1
                                                })
                                              ])
                                            ]))
                                          : (_ctx.type=='20')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "境外发货人",
                                                    "label-width": "85px"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_miezz_input, {
                                                        trim: false,
                                                        modelValue: _ctx.form.Data.ConsignorCode,
                                                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.form.Data.ConsignorCode) = $event)),
                                                        placeholder: "请填写",
                                                        onHandleBlur: _ctx.onTrimSpace
                                                      }, null, 8, ["modelValue", "onHandleBlur"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_36, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "25px",
                                                    label: " ",
                                                    prop: "ConsignorCompanyName"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_miezz_input, {
                                                        trim: false,
                                                        modelValue: _ctx.form.Data.ConsignorCompanyName,
                                                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.form.Data.ConsignorCompanyName) = $event)),
                                                        placeholder: "请填写",
                                                        onHandleBlur: _ctx.onTrimSpace
                                                      }, null, 8, ["modelValue", "onHandleBlur"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("td", _hoisted_37, [
                                        _createElementVNode("div", null, [
                                          _hoisted_38,
                                          _createVNode(_component_el_form_item, {
                                            label: "运输方式",
                                            "label-width": "70px",
                                            style: {"margin-top":"-34px"}
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_39, [
                                          _createVNode(_component_el_form_item, {
                                            "label-width": "25px",
                                            label: " ",
                                            prop: "TransportModeId"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_miezz_select, {
                                                clearable: false,
                                                modelValue: _ctx.form.Data.TransportModeId,
                                                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.form.Data.TransportModeId) = $event)),
                                                options: _ctx.transportModes,
                                                onHandleChange: _ctx.onChangeTransportModeId,
                                                valueKey: "Value",
                                                labelKey: "Label",
                                                style: {"width":"100% !important"}
                                              }, null, 8, ["modelValue", "options", "onHandleChange"])
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_40, [
                                        _createElementVNode("div", null, [
                                          _hoisted_41,
                                          _createVNode(_component_el_form_item, {
                                            label: "运输工具名称及航次号",
                                            "label-width": "155px",
                                            style: {"margin-top":"-34px"}
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_42, [
                                          _createVNode(_component_el_form_item, { "label-width": "0px" })
                                        ])
                                      ]),
                                      (_ctx.type=='10')
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_43, [
                                            _createElementVNode("div", null, [
                                              _hoisted_44,
                                              _createVNode(_component_el_form_item, {
                                                label: "提运单号",
                                                "label-width": "70px",
                                                style: {"margin-top":"-34px"}
                                              })
                                            ]),
                                            _createElementVNode("div", _hoisted_45, [
                                              _createVNode(_component_el_form_item, { "label-width": "0px" })
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.type=='20')
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_46, [
                                            _createElementVNode("div", null, [
                                              _hoisted_47,
                                              _createVNode(_component_el_form_item, {
                                                label: "提运单号",
                                                "label-width": "70px",
                                                style: {"margin-top":"-34px"}
                                              })
                                            ]),
                                            _createElementVNode("div", _hoisted_48, [
                                              _createVNode(_component_el_form_item, { "label-width": "0px" })
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.type=='20')
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_49, [
                                            _createElementVNode("div", null, [
                                              _hoisted_50,
                                              _createVNode(_component_el_form_item, {
                                                label: "货物存放地点",
                                                "label-width": "96px",
                                                style: {"margin-top":"-34px"}
                                              })
                                            ]),
                                            _hoisted_51
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_52, [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_el_form_item, {
                                            label: _ctx.type=='10'?'生产销售单位':'消费使用单位',
                                            "label-width": "108px",
                                            prop: "ProductionSaleCode"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_autocomplete, {
                                                modelValue: _ctx.form.Data.ProductionSaleCode,
                                                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.form.Data.ProductionSaleCode) = $event)),
                                                clearable: true,
                                                "fetch-suggestions": _ctx.querySearchProductionSaleCodeAsync,
                                                "popper-class": "my-autocomplete",
                                                placeholder: "请填写关键词",
                                                onSelect: _ctx.handleSelectProductionSaleCode,
                                                onChange: _ctx.onTrimSpace
                                              }, {
                                                default: _withCtx(({ item }) => [
                                                  _createElementVNode("span", _hoisted_53, _toDisplayString(item.Name), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange"])
                                            ]),
                                            _: 2
                                          }, 1032, ["label"])
                                        ]),
                                        _createElementVNode("div", _hoisted_54, [
                                          _createVNode(_component_el_form_item, {
                                            "label-width": "25px",
                                            label: " ",
                                            prop: "ProductionSaleCompanyName"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_autocomplete, {
                                                modelValue: _ctx.form.Data.ProductionSaleCompanyName,
                                                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.form.Data.ProductionSaleCompanyName) = $event)),
                                                clearable: true,
                                                "fetch-suggestions": _ctx.querySearchProductionSaleCodeAsync,
                                                "popper-class": "my-autocomplete",
                                                placeholder: "请填写关键词",
                                                onSelect: _ctx.handleSelectProductionSaleCode,
                                                onChange: _ctx.onTrimSpace
                                              }, {
                                                default: _withCtx(({ item }) => [
                                                  _createElementVNode("span", _hoisted_55, _toDisplayString(item.Name), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_56, [
                                        _createElementVNode("div", null, [
                                          _hoisted_57,
                                          _createVNode(_component_el_form_item, {
                                            label: "监管方式",
                                            "label-width": "70px",
                                            style: {"margin-top":"-34px"}
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_58, [
                                          _createVNode(_component_el_form_item, {
                                            "label-width": "25px",
                                            label: " ",
                                            prop: "SupervisionModeId"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_autocomplete, {
                                                modelValue: _ctx.form.Data.SupervisionModeName,
                                                "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.form.Data.SupervisionModeName) = $event)),
                                                clearable: false,
                                                "fetch-suggestions": _ctx.querySearchSupervisionModeIdAsync,
                                                "popper-class": "my-autocomplete",
                                                placeholder: "请填写关键词",
                                                onSelect: _ctx.handleSelectSupervisionModeId,
                                                onChange: _ctx.onChangeSupervisionModeId,
                                                onClear: _ctx.onChangeSupervisionModeId
                                              }, {
                                                default: _withCtx(({ item }) => [
                                                  _createElementVNode("span", _hoisted_59, _toDisplayString(item.Label), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange", "onClear"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_60, [
                                        _createElementVNode("div", null, [
                                          _hoisted_61,
                                          _createVNode(_component_el_form_item, {
                                            label: "征免性质",
                                            "label-width": "70px",
                                            style: {"margin-top":"-34px"}
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_62, [
                                          _createVNode(_component_el_form_item, {
                                            "label-width": "25px",
                                            label: " ",
                                            prop: "ExemptionNatureId"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_autocomplete, {
                                                clearable: false,
                                                modelValue: _ctx.form.Data.ExemptionNatureName,
                                                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.form.Data.ExemptionNatureName) = $event)),
                                                "fetch-suggestions": _ctx.querySearchExemptionNatureIdAsync,
                                                "popper-class": "my-autocomplete",
                                                placeholder: "请填写关键词",
                                                onSelect: _ctx.handleSelectExemptionNatureId,
                                                onChange: _ctx.onChangeExemptionNatureId,
                                                onClear: _ctx.onChangeExemptionNatureId
                                              }, {
                                                default: _withCtx(({ item }) => [
                                                  _createElementVNode("span", _hoisted_63, _toDisplayString(item.Label), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange", "onClear"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]),
                                      (_ctx.type=='10')
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_64, [
                                            _createElementVNode("div", null, [
                                              _hoisted_65,
                                              _createVNode(_component_el_form_item, {
                                                label: "许可证号",
                                                "label-width": "70px",
                                                style: {"margin-top":"-34px"}
                                              })
                                            ]),
                                            _createElementVNode("div", _hoisted_66, [
                                              _createVNode(_component_el_form_item, {
                                                "label-width": "0px",
                                                prop: "PermitNumber"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_input, {
                                                    modelValue: _ctx.form.Data.PermitNumber,
                                                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.form.Data.PermitNumber) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.type=='20')
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_67, [
                                            _createElementVNode("div", null, [
                                              _hoisted_68,
                                              _createVNode(_component_el_form_item, {
                                                label: "许可证号",
                                                "label-width": "70px",
                                                style: {"margin-top":"-34px"}
                                              })
                                            ]),
                                            _createElementVNode("div", _hoisted_69, [
                                              _createVNode(_component_el_form_item, {
                                                "label-width": "0px",
                                                prop: "PermitNumber"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_input, {
                                                    modelValue: _ctx.form.Data.PermitNumber,
                                                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.form.Data.PermitNumber) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.type=='20')
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_70, [
                                            _createElementVNode("div", null, [
                                              _hoisted_71,
                                              _createVNode(_component_el_form_item, {
                                                label: "启运港",
                                                "label-width": "55px",
                                                style: {"margin-top":"-34px"}
                                              })
                                            ]),
                                            _createElementVNode("div", _hoisted_72, [
                                              _createVNode(_component_el_form_item, {
                                                "label-width": "0px",
                                                prop: "DeparturePort"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.form.Data.DeparturePort) + "  ", 1)
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_73, [
                                        _createElementVNode("div", null, [
                                          _hoisted_74,
                                          _createVNode(_component_el_form_item, {
                                            label: "合同协议号",
                                            "label-width": "85px",
                                            style: {"margin-top":"-34px"}
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_75, [
                                          _createVNode(_component_el_form_item, {
                                            "label-width": "25px",
                                            label: " "
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.form.Data.ContractNumber), 1)
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_76, [
                                        _createElementVNode("div", null, [
                                          _hoisted_77,
                                          _createVNode(_component_el_form_item, {
                                            label: "贸易国（地区）",
                                            "label-width": "110px",
                                            style: {"margin-top":"-34px"}
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_78, [
                                          _createVNode(_component_el_form_item, {
                                            "label-width": "25px",
                                            label: " ",
                                            prop: "TradingCountryId"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_autocomplete, {
                                                modelValue: _ctx.form.Data.TradingCountryName,
                                                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.form.Data.TradingCountryName) = $event)),
                                                clearable: false,
                                                "fetch-suggestions": _ctx.querySearchTradingCountryIdAsync,
                                                "popper-class": "my-autocomplete",
                                                placeholder: "请填写关键词",
                                                onSelect: _ctx.handleSelectTradingCountryId,
                                                onChange: _ctx.onChangeTradingCountryId,
                                                onClear: _ctx.onChangeTradingCountryId
                                              }, {
                                                default: _withCtx(({ item }) => [
                                                  _createElementVNode("span", _hoisted_79, _toDisplayString(item.Label), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange", "onClear"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_80, [
                                        (_ctx.type=='10')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                              _createElementVNode("div", null, [
                                                _hoisted_82,
                                                _createVNode(_component_el_form_item, {
                                                  label: "运抵国（地区）",
                                                  "label-width": "110px",
                                                  style: {"margin-top":"-34px"}
                                                })
                                              ]),
                                              _createElementVNode("div", _hoisted_83, [
                                                _createVNode(_component_el_form_item, {
                                                  "label-width": "25px",
                                                  label: " ",
                                                  prop: "ArrivalCountryId"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_autocomplete, {
                                                      modelValue: _ctx.form.Data.ArrivalCountryName,
                                                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.form.Data.ArrivalCountryName) = $event)),
                                                      clearable: false,
                                                      "fetch-suggestions": _ctx.querySearchArrivalCountryIdAsync,
                                                      "popper-class": "my-autocomplete",
                                                      placeholder: "请填写关键词",
                                                      onSelect: _ctx.handleSelectArrivalCountryId,
                                                      onChange: _ctx.onChangeArrivalCountryId,
                                                      onClear: _ctx.onChangeArrivalCountryId
                                                    }, {
                                                      default: _withCtx(({ item }) => [
                                                        _createElementVNode("span", _hoisted_84, _toDisplayString(item.Label), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange", "onClear"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ]))
                                          : (_ctx.type=='20')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_86,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "启运国（地区）",
                                                    "label-width": "110px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_87, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "25px",
                                                    label: " ",
                                                    prop: "DepartureCountryId"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_autocomplete, {
                                                        modelValue: _ctx.form.Data.DepartureCountryName,
                                                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.form.Data.DepartureCountryName) = $event)),
                                                        clearable: false,
                                                        "fetch-suggestions": _ctx.querySearchDepartureCountryIdAsync,
                                                        "popper-class": "my-autocomplete",
                                                        placeholder: "请填写关键词",
                                                        onSelect: _ctx.handleSelectDepartureCountryId,
                                                        onChange: _ctx.onChangeDepartureCountryId,
                                                        onClear: _ctx.onChangeDepartureCountryId
                                                      }, {
                                                        default: _withCtx(({ item }) => [
                                                          _createElementVNode("span", _hoisted_88, _toDisplayString(item.Label), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange", "onClear"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("td", _hoisted_89, [
                                        (_ctx.type=='10')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                              _createElementVNode("div", null, [
                                                _hoisted_91,
                                                _createVNode(_component_el_form_item, {
                                                  label: "指运港",
                                                  "label-width": "55px",
                                                  style: {"margin-top":"-34px"}
                                                })
                                              ]),
                                              _createElementVNode("div", {
                                                style: {"margin-top":"16px","height":"43px","width":"100%","word-break":"break-all","overflow":"hidden"},
                                                title: _ctx.form.Data.PortOfDestination
                                              }, [
                                                _createVNode(_component_el_form_item, { "label-width": "6px" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.form.Data.PortOfDestination), 1)
                                                  ]),
                                                  _: 1
                                                })
                                              ], 8, _hoisted_92)
                                            ]))
                                          : (_ctx.type=='20')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_94,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "经停港",
                                                    "label-width": "55px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_95, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "25px",
                                                    label: " ",
                                                    prop: "StopPortId"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_autocomplete, {
                                                        modelValue: _ctx.form.Data.StopPortName,
                                                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.form.Data.StopPortName) = $event)),
                                                        clearable: false,
                                                        "fetch-suggestions": _ctx.querySearchStopPortIdAsync,
                                                        "popper-class": "my-autocomplete",
                                                        placeholder: "请填写关键词",
                                                        onSelect: _ctx.handleSelectStopPortId,
                                                        onChange: _ctx.onChangeStopPortId,
                                                        onClear: _ctx.onChangeStopPortId
                                                      }, {
                                                        default: _withCtx(({ item }) => [
                                                          _createElementVNode("span", _hoisted_96, _toDisplayString(item.Label), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange", "onClear"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("td", _hoisted_97, [
                                        (_ctx.type=='10')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                              _createElementVNode("div", null, [
                                                _hoisted_99,
                                                _createVNode(_component_el_form_item, {
                                                  label: "离境口岸",
                                                  "label-width": "70px",
                                                  style: {"margin-top":"-34px"}
                                                })
                                              ]),
                                              _createElementVNode("div", _hoisted_100, [
                                                _createVNode(_component_el_form_item, { "label-width": "6px" })
                                              ])
                                            ]))
                                          : (_ctx.type=='20')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_102,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "入境口岸",
                                                    "label-width": "70px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_103, [
                                                  _createVNode(_component_el_form_item, { "label-width": "6px" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.form.Data.EntryPort) + "  ", 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_104, [
                                        _createElementVNode("div", null, [
                                          _hoisted_105,
                                          _createVNode(_component_el_form_item, {
                                            label: "包装种类",
                                            "label-width": "70px",
                                            style: {"margin-top":"-34px"}
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_106, [
                                          _createVNode(_component_el_form_item, {
                                            "label-width": "25px",
                                            label: " ",
                                            prop: "PackName"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_miezz_select, {
                                                clearable: false,
                                                modelValue: _ctx.form.Data.PackName,
                                                "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.form.Data.PackName) = $event)),
                                                options: _ctx.packages,
                                                onHandleChange: _ctx.onChangePackName,
                                                valueKey: "Label",
                                                labelKey: "Label",
                                                style: {"width":"65% !important"}
                                              }, null, 8, ["modelValue", "options", "onHandleChange"]),
                                              _createVNode(_component_el_button, {
                                                onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.onPackage())),
                                                type: "info",
                                                plain: "",
                                                style: {"min-width":"80px","width":"30%","text-align":"center","margin-left":"10px","padding-left":"5px","padding-right":"5px"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("其他包装")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_107, [
                                        _createElementVNode("div", null, [
                                          _hoisted_108,
                                          _createVNode(_component_el_form_item, {
                                            label: "件数",
                                            "label-width": "40px",
                                            style: {"margin-top":"-34px"}
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_109, [
                                          _createVNode(_component_el_form_item, { "label-width": "0px" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.form.Data.ProductNumber) + "  ", 1)
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_110, [
                                        _createElementVNode("div", null, [
                                          _hoisted_111,
                                          _createVNode(_component_el_form_item, {
                                            label: "毛重（千克）",
                                            "label-width": "98px",
                                            style: {"margin-top":"-34px"}
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_112, [
                                          _createVNode(_component_el_form_item, { "label-width": "0px" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.form.Data.ProductGrossWeight) + "  ", 1)
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_113, [
                                        _createElementVNode("div", null, [
                                          _hoisted_114,
                                          _createVNode(_component_el_form_item, {
                                            label: "净重（千克）",
                                            "label-width": "98px",
                                            style: {"margin-top":"-34px"}
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_115, [
                                          _createVNode(_component_el_form_item, { "label-width": "0px" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.form.Data.ProductNetWeight) + "  ", 1)
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_116, [
                                        _createElementVNode("div", null, [
                                          _hoisted_117,
                                          _createVNode(_component_el_form_item, {
                                            label: "成交方式",
                                            "label-width": "70px",
                                            style: {"margin-top":"-34px"}
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_118, [
                                          _createVNode(_component_el_form_item, {
                                            "label-width": "25px",
                                            label: " ",
                                            prop: "TransactionModeId"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_select, {
                                                filterable: "",
                                                modelValue: _ctx.form.Data.TransactionModeId,
                                                "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.form.Data.TransactionModeId) = $event)),
                                                placeholder: "请选择",
                                                onChange: _cache[57] || (_cache[57] = ($event: any) => (_ctx.onChangeTransactionMode()))
                                              }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactionModes, (item) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: item.Value,
                                                      label: item.Label,
                                                      value: item.Value
                                                    }, null, 8, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_119, [
                                        _createElementVNode("div", null, [
                                          _hoisted_120,
                                          _createVNode(_component_el_form_item, {
                                            label: "运费",
                                            "label-width": "40px",
                                            style: {"margin-top":"-34px","text-align":"right"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_121, [
                                                _hoisted_122,
                                                _createElementVNode("a", {
                                                  href: "javascript:;",
                                                  onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.onCurrency(_ctx.form.Data.FreightCurrencySystemId,'FreightCurrencySystemId'))),
                                                  tabindex: "-1",
                                                  style: {"text-decoration":"underline","color":"#fe995b"}
                                                }, _toDisplayString(_ctx.form.Data.FreightCurrencySystemName), 1)
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_123, [
                                          (_ctx.isFreight==true)
                                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                key: 0,
                                                "label-width": "25px",
                                                label: " ",
                                                prop: "Freight"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_miezz_input, {
                                                    onHandleBlur: _ctx.onChangeFreight,
                                                    modelValue: _ctx.form.Data.Freight,
                                                    "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.form.Data.Freight) = $event)),
                                                    placeholder: '请填写',
                                                    style: {"width":"100% !important"}
                                                  }, null, 8, ["onHandleBlur", "modelValue"])
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_miezz_input, {
                                                    disabled: true,
                                                    modelValue: _ctx.form.Data.Freight,
                                                    "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.form.Data.Freight) = $event)),
                                                    placeholder: '请填写',
                                                    style: {"width":"100% !important"}
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              }))
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_124, [
                                        _createElementVNode("div", null, [
                                          _hoisted_125,
                                          _createVNode(_component_el_form_item, {
                                            label: "保费",
                                            "label-width": "40px",
                                            style: {"margin-top":"-34px","text-align":"right"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_126, [
                                                _hoisted_127,
                                                _createElementVNode("a", {
                                                  href: "javascript:;",
                                                  onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.onCurrency(_ctx.form.Data.PremiumCurrencySystemId,'PremiumCurrencySystemId'))),
                                                  tabindex: "-1",
                                                  style: {"text-decoration":"underline","color":"#fe995b"}
                                                }, _toDisplayString(_ctx.form.Data.PremiumCurrencySystemName), 1)
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_128, [
                                          (_ctx.isPremium==true)
                                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                key: 0,
                                                "label-width": "25px",
                                                label: " ",
                                                prop: "Premium"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_miezz_input, {
                                                    onHandleBlur: _ctx.onChangePremium,
                                                    modelValue: _ctx.form.Data.Premium,
                                                    "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.form.Data.Premium) = $event)),
                                                    placeholder: '请填写',
                                                    style: {"width":"100% !important"}
                                                  }, null, 8, ["onHandleBlur", "modelValue"])
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_miezz_input, {
                                                    disabled: true,
                                                    modelValue: _ctx.form.Data.Premium,
                                                    "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.form.Data.Premium) = $event)),
                                                    placeholder: '请填写',
                                                    style: {"width":"100% !important"}
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              }))
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_129, [
                                        _createElementVNode("div", null, [
                                          _hoisted_130,
                                          _createVNode(_component_el_form_item, {
                                            label: "杂费",
                                            "label-width": "40px",
                                            style: {"margin-top":"-34px","text-align":"right"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_131, [
                                                _hoisted_132,
                                                _createElementVNode("a", {
                                                  href: "javascript:;",
                                                  onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.onCurrency(_ctx.form.Data.IncidentalCurrencySystemId,'IncidentalCurrencySystemId'))),
                                                  tabindex: "-1",
                                                  style: {"text-decoration":"underline","color":"#fe995b"}
                                                }, _toDisplayString(_ctx.form.Data.IncidentalCurrencySystemName), 1)
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_133, [
                                          _createVNode(_component_el_form_item, {
                                            "label-width": "0px",
                                            prop: "Incidental"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_miezz_input, {
                                                onHandleBlur: _ctx.onChangeIncidental,
                                                modelValue: _ctx.form.Data.Incidental,
                                                "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.form.Data.Incidental) = $event)),
                                                placeholder: '请填写',
                                                style: {"width":"100% !important"}
                                              }, null, 8, ["onHandleBlur", "modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_134, [
                                        _createVNode(_component_el_form_item, {
                                          label: "随附单证及编号",
                                          "label-width": "150px",
                                          style: {"margin-top":"5px"}
                                        }),
                                        _createVNode(_component_el_form_item, {
                                          label: "随附单证代码",
                                          "label-width": "150px",
                                          style: {"margin-top":"10px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.form.Data.AttachedCode), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("div", _hoisted_135, [
                                          (_ctx.isElectronicAccountDataNumber == true)
                                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                key: 0,
                                                label: "电子底账数据号码",
                                                "label-width": "150px"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: " ",
                                                    "label-width": "25px",
                                                    prop: "ElectronicAccountDataNumber"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_miezz_input, {
                                                        placeholder: '请填写报检电子回执上的企业报检电子底账号码',
                                                        trim: false,
                                                        modelValue: _ctx.form.Data.ElectronicAccountDataNumber,
                                                        "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.form.Data.ElectronicAccountDataNumber) = $event)),
                                                        style: {"width":"40% !important"}
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_el_form_item, {
                                                key: 1,
                                                label: "电子底账数据号码",
                                                "label-width": "150px"
                                              }))
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_136, [
                                        _createVNode(_component_el_form_item, {
                                          label: "标记唛码及备注",
                                          "label-width": "150px"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              type: "textarea",
                                              autosize: { minRows:5, maxRows: 20},
                                              placeholder: "请输入唛头",
                                              style: {"width":"80% !important"},
                                              modelValue: _ctx.form.Data.CustomsShippingMark,
                                              "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.form.Data.CustomsShippingMark) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _hoisted_137
                                      ])
                                    ]),
                                    _createElementVNode("tr", null, [
                                      (_openBlock(), _createElementBlock("td", {
                                        class: "cell",
                                        colspan: "8",
                                        key: _ctx.productRandom
                                      }, [
                                        _createVNode(_component_el_form_item, {
                                          label: "",
                                          "label-width": "0px",
                                          prop: "DocumentProductCount"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: _ctx.form.Data.DocumentProductCount,
                                              "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.form.Data.DocumentProductCount) = $event)),
                                              style: {"display":"none"}
                                            }, null, 8, ["modelValue"]),
                                            _createElementVNode("div", _hoisted_138, [
                                              _hoisted_139,
                                              _createElementVNode("div", _hoisted_140, [
                                                _createVNode(_component_el_dropdown, {
                                                  trigger: "click",
                                                  onCommand: _ctx.handleProductChange
                                                }, {
                                                  dropdown: _withCtx(() => [
                                                    _createVNode(_component_el_dropdown_menu, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_el_dropdown_item, { command: '包装' }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("从包装列表中选择")
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_el_dropdown_item, { command: '手动' }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("手动添加")
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_button, {
                                                      type: "primary",
                                                      size: "small"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_el_icon, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_Plus)
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createTextVNode(" 添加"),
                                                        _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_arrow_down)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["onCommand"])
                                              ])
                                            ]),
                                            (_ctx.form.Data.DocumentProducts==null || _ctx.form.Data.DocumentProducts==undefined || _ctx.form.Data.DocumentProducts.length<=0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_141, _hoisted_143))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                                  _createElementVNode("table", _hoisted_145, [
                                                    _hoisted_146,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.DocumentProducts, (p, index) => {
                                                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                        _createElementVNode("td", _hoisted_147, [
                                                          _createElementVNode("div", _hoisted_148, [
                                                            _createElementVNode("div", {
                                                              style: _normalizeStyle([{"width":"4%","float":"left"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                            }, _toDisplayString(index + 1), 5),
                                                            _createElementVNode("div", {
                                                              style: _normalizeStyle([{"width":"9%","float":"left","word-break":"break-all"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                            }, _toDisplayString(p.RecordOrder) + " ", 5),
                                                            _createElementVNode("div", {
                                                              style: _normalizeStyle([{"width":"7%","float":"left"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                            }, _toDisplayString(p.HsCode) + " ", 5),
                                                            _createElementVNode("div", {
                                                              style: _normalizeStyle([{"width":"15%","float":"left"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                            }, [
                                                              _createTextVNode(_toDisplayString(p.ProductNameZh) + "/" + _toDisplayString(p.ProductNameEn) + " ", 1),
                                                              _hoisted_149,
                                                              _createTextVNode(" " + _toDisplayString(p.SpecName) + "   ", 1)
                                                            ], 4),
                                                            _createElementVNode("div", {
                                                              style: _normalizeStyle([{"float":"left","width":"10%"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                innerHTML: p.NewPrice
                                                              }, null, 8, _hoisted_150),
                                                              _createTextVNode("   ")
                                                            ], 4),
                                                            _createElementVNode("div", {
                                                              style: _normalizeStyle([{"float":"left","width":"8%"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                            }, [
                                                              (p.UnitPrice!=null && p.UnitPrice!='')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                                                                    _createElementVNode("p", _hoisted_152, _toDisplayString(p.UnitPrice) + " ", 1),
                                                                    _createElementVNode("p", _hoisted_153, _toDisplayString(p.TotalPrice) + " ", 1),
                                                                    _createElementVNode("p", _hoisted_154, _toDisplayString(p.CurrencySystemName) + " ", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              _createTextVNode("   ")
                                                            ], 4),
                                                            _createElementVNode("div", {
                                                              style: _normalizeStyle([{"float":"left","width":"12%","word-break":"break-all"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                            }, _toDisplayString(p.OriginCountryName) + " ", 5),
                                                            _createElementVNode("div", {
                                                              style: _normalizeStyle([{"float":"left","width":"12%","word-break":"break-all"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                            }, _toDisplayString(p.FinanCountryName) + " ", 5),
                                                            _createElementVNode("div", {
                                                              style: _normalizeStyle([{"float":"left","width":"12%","word-break":"break-all"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                            }, _toDisplayString(p.DomesticGoodsPlaceName) + " ", 5),
                                                            _createElementVNode("div", {
                                                              style: _normalizeStyle([{"float":"left","width":"6%"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                            }, _toDisplayString(p.ExemptingModeName) + " ", 5),
                                                            _createElementVNode("div", _hoisted_155, [
                                                              _createElementVNode("a", {
                                                                href: "javascript:;",
                                                                onClick: ($event: any) => (_ctx.onEditProduct(p,index)),
                                                                title: "编辑相关信息"
                                                              }, [
                                                                _createVNode(_component_el_icon, {
                                                                  style: _normalizeStyle((p.IsTemporary==null || p.IsTemporary == true)?'color:red;':'')
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_Edit)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["style"])
                                                              ], 8, _hoisted_156),
                                                              _createTextVNode("  "),
                                                              _createElementVNode("a", {
                                                                href: "javascript:;",
                                                                onClick: ($event: any) => (_ctx.onDeleteProduct(index)),
                                                                title: "删除",
                                                                style: {"color":"#cc3333"}
                                                              }, [
                                                                _createVNode(_component_el_icon, {
                                                                  style: _normalizeStyle((p.IsTemporary==null || p.IsTemporary == true)?'color:red;':'')
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_Delete)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["style"])
                                                              ], 8, _hoisted_157)
                                                            ]),
                                                            _hoisted_158
                                                          ]),
                                                          _createElementVNode("div", {
                                                            style: {"clear":"both","font-size":"13px","height":"24px","line-height":"24px","color":"#666","padding-top":"5px"},
                                                            innerHTML: '申报要素：' + p.DeclarationElement
                                                          }, null, 8, _hoisted_159)
                                                        ])
                                                      ]))
                                                    }), 128))
                                                  ])
                                                ]))
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    ])
                                  ]),
                                  _createVNode(_component_el_form_item, {
                                    label: "附件",
                                    "label-width": "40px"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_upload, {
                                        modelValue: _ctx.form.Data.DocumentAnnexs,
                                        "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.form.Data.DocumentAnnexs) = $event)),
                                        path: "document/annex",
                                        accept: "file/*",
                                        prop: "Url",
                                        maxSize: 5 * 1024 * 1024,
                                        tip: '系统将自动生成装箱单/发票/合同，如有其他申报所需的文件，请上传。'
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.packRuleForm.Visible,
      "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.packRuleForm.Visible) = $event)),
      "show-close": false,
      top: "10px",
      style: {"width":"50%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_160,
        _createElementVNode("div", _hoisted_161, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _ctx.packages,
          ref: "packageTable",
          stripe: "",
          style: {"width":"100%"},
          onSelectionChange: _ctx.handleSelectionPackageChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              width: "55"
            }),
            _createVNode(_component_el_table_column, {
              type: "index",
              label: "序号",
              width: "80"
            }),
            _createVNode(_component_el_table_column, {
              prop: "Data",
              label: "包装种类代码",
              width: "200"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.Data.Code), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "Label",
              label: "包装种类名称"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.Label), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "onSelectionChange"]),
        _createElementVNode("div", _hoisted_162, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.packageBottomButtons,
            "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.packageBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickPackage
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_currency, {
      isRate: false,
      defaultCurrency: '美元',
      ref: "Currency",
      onOnSelectCurrency: _ctx.onSelectCurrency
    }, null, 8, ["onOnSelectCurrency"]),
    _createVNode(_component_miezz_customs_product, {
      isTemporary: _ctx.form.Data.IsTemporary,
      type: _ctx.type,
      defaultCurrencyId: _ctx.consigneeCurrencyId,
      defaultCurrencyCode: _ctx.consigneeCurrencyCode,
      defaultOriginCountryName: _ctx.dispatchCountryName,
      defaultFinanCountryName: _ctx.destinationCountryName,
      defaultOriginCountryId: _ctx.dispatchCountryId,
      defaultFinanCountryId: _ctx.destinationCountryId,
      ref: "CustomsProduct",
      onOnSelectCustomsProduct: _ctx.onSelectCustomsProduct
    }, null, 8, ["isTemporary", "type", "defaultCurrencyId", "defaultCurrencyCode", "defaultOriginCountryName", "defaultFinanCountryName", "defaultOriginCountryId", "defaultFinanCountryId", "onOnSelectCustomsProduct"]),
    _createVNode(_component_miezz_customs_package, {
      isSelectCompany: false,
      ref: "CustomsPackage",
      onOnSelectProductPackage: _ctx.onSelectProductPackage
    }, null, 8, ["onOnSelectProductPackage"]),
    _createVNode(_component_miezz_button_bar, {
      modelValue: _ctx.bottomButtons,
      "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.bottomButtons) = $event)),
      onHandleClick: _ctx.handleClick
    }, null, 8, ["modelValue", "onHandleClick"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalBusinessCard,
      "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.modalBusinessCard) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_company_business_card_form, {
          modelValue: _ctx.modalBusinessCard,
          "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.modalBusinessCard) = $event)),
          id: _ctx.businessCardId,
          companyId: _ctx.businessCardCompanyId,
          parentId: _ctx.businessCardParentId,
          area: _ctx.businessCardArea,
          type: _ctx.businessCardType,
          content: _ctx.businessCardContent,
          onHandleSubmit: _ctx.handleSubmitBusinessCard
        }, null, 8, ["modelValue", "id", "companyId", "parentId", "area", "type", "content", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalBusinessCardBank,
      "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.modalBusinessCardBank) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_company_business_card_bank_form, {
          modelValue: _ctx.modalBusinessCardBank,
          "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.modalBusinessCardBank) = $event)),
          id: _ctx.businessCardBankId,
          businessCardId: _ctx.businessCardId,
          content: _ctx.businessCardContent,
          onHandleSubmit: _ctx.handleSubmitBusinessCardBank
        }, null, 8, ["modelValue", "id", "businessCardId", "content", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "系统提示",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false,
      modelValue: _ctx.TransactionModeTip.Visible,
      "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.TransactionModeTip.Visible) = $event)),
      width: "30%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_163, "贸易条款" + _toDisplayString(_ctx.TransactionModeTip.TradeTermName) + "建议用成交方式" + _toDisplayString(_ctx.TransactionModeTip.DefaultTransactionMode) + "进行申报，如用其他成交方式申报，在退税申报时请注意调整，是否仍然采用" + _toDisplayString(_ctx.TransactionModeTip.SelectTransactionMode) + "进行申报？", 1),
        _createElementVNode("div", _hoisted_164, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.transactionModeTipBottomButtons,
            "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.transactionModeTipBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickTransactionModeTip
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}